[
  {
    "id": "id-1",
    "name": "1",
    "description": "Ви замовляєте букет через каталог"
  },
  {
    "id": "id-2",
    "name": "2",
    "description": "Ви оплачуєте товар через картку VISA або MC, або Приват24"
  },
  {
    "id": "id-3",
    "name": "3",
    "description": "Вам передзвонять наші менеджери, якщо потрібно щось уточнити"
  },
  {
    "id": "id-4",
    "name": "4",
    "description": "Надсилаємо фото зібраного букета, щоб узгодити все"
  },
  {
    "id": "id-5",
    "name": "5",
    "description": "Доставляємо букет одержувачу протягом 2-х годин"
  },
  {
    "id": "id-6",
    "name": "6",
    "description": "Сповістимо Вас дзвінком або повідомленням про доставку букета"
  }
]
